import { AddMemberForm } from "../AddMemberForm";

export const AddMember = () => {
  return <AddMemberForm />;
};
